<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Usuario</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <user-form
          v-if="isDataLoaded"
          :title="`Editar usuario: ${user.name}`"
          :server-errors="serverErrors"
          :user="user"
          @save="saveUser"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import UserForm from './Forms/UserForm';
import swal from 'sweetalert2';

export default {
  name: 'UsersEdit',
  components: {
    RouteBreadCrumb,
    UserForm,
  },

  data() {
    return {
      isDataLoaded: false,
      user: null,
      serverErrors: [],
    };
  },

  created() {
    const userId = this.$route.params.id;
    this.fetchUser(userId);
  },

  methods: {
    fetchUser(userId) {
      this.$services
        .resource('users')
        .show(userId, { include: 'role' })
        .then((res) => res.data.data)
        .then((user) => {
          this.user = user;
          this.user.role = user.role ? user.role.id : null;
          this.isDataLoaded = true;
        });
    },

    saveUser(user) {
      this.serverErrors = [];
      this.$services
        .resource('users')
        .update(this.user.id, user)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El usuario fue actualizado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'UsersList' }));
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },
  },
};
</script>
